import useOperationalAccess from "./hooks/useOperationalAccess";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Sections
import { UserSelect } from "./pages/login/userSelect";
import { Commander } from "./pages/commander";
import { Alert } from "./components/alert";
import { setComponentActive } from "./reducers/userConfigSlice";
import { Cash } from "./pages/cash";
import { History } from "./pages/history";
import { Header } from "./pages/header";
import packageJson from "../package.json";
import "./tpv-workspace.css";
import "./tpv-reference.css";
import "./tpv-layout-parity.css";
import Initializer from "./hooks/initializer";

function App() {
  useOperationalAccess();
  const [ready, setReady] = useState(false);
  const [cashOpening, setCashOpening] = useState(false);
  const dispatch = useDispatch();

  const logged = useSelector(
    (state) => state.aplicationConfig.userConfig.logged
  );
  const componentActive = useSelector(
    (state) => state.aplicationConfig.userConfig.componentActive
  );

  useEffect(() => {
    if (componentActive !== "cash") setCashOpening(false);
  }, [componentActive]);

  const cashPoint = useSelector(s => s.aplicationConfig.corporationData?.pointConfig?.PointOfSaleConfigurationId);
  const cashOperator = useSelector(s => s.aplicationConfig.userConfig.data?.userId);

  const appVersion = useMemo(() => {
    const version = packageJson?.version ?? "";
    const utilsVersionRaw = packageJson?.dependencies?.["@delibrandev/utils"];
    const utilsVersion =
      typeof utilsVersionRaw === "string"
        ? utilsVersionRaw.replace("^", "")
        : "";
    return `${version}${utilsVersion ? "/" + utilsVersion : ""}`;
  }, []);

  const content = useMemo(() => {
    // Si no está logueado, siempre mostramos selección de usuario
    if (!logged) return <UserSelect defaultMenu={componentActive === "switchAccount" ? "users" : "password"} />;

    switch (componentActive) {
      case "userSelect":
        return <UserSelect onInit={setReady} />;

      case "switchAccount":
        return <UserSelect defaultMenu={"users"} />;

      case "commander":
        return (
          <>
            <Header />
            <Commander onOpenCash={() => { setCashOpening(true); dispatch(setComponentActive("cash")); }} />
          </>
        );

      case "cash":
        return (
          <>
            <Header />
            <Cash expectedPointId={cashPoint} expectedOperatorId={cashOperator} openOnLoad={cashOpening} />
          </>
        );

      case "history":
        return (
          <>
            <Header />
            <History />
          </>
        );

      default:
        // Fallback seguro si llega un estado inesperado
        return <UserSelect />;
    }
  }, [logged, componentActive, cashPoint, cashOperator, cashOpening, dispatch]);

  return (
    <>
      <Initializer onInit={() => setReady(true)} />
      <div className={logged && !["userSelect", "switchAccount"].includes(componentActive) ? "tpvWorkspace" : "tpvAccess"}>{ready ? content : null}</div>
      <Alert />
      <div className="appVersion">{appVersion}</div>
    </>
  );
}

export default App;
